import { axios } from 'api'

type SignUpFormValues = {
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
  faxNumber?: string
  companyName: string
  addressLine1: string
  addressLine2?: string
  city: string
  state: string
  zipCode: string
  currentSupplier: string
  averagePurchase: string
  services: string[]
  taxId: string
  source: string
  businessType: string
}

export const signUp = async (formData: SignUpFormValues) => {
  const response = await axios.post('/accounts/signup', formData)
  if (response.status === 200) {
    return { success: true }
  } else if (response.status === 409) {
    return {
      success: false,
      exists: true,
      error: response.data.error || 'Sign up failed. Please try again.'
    }
  } else {
    return {
      success: false,
      error: response.data.error || 'Sign up failed. Please try again.'
    }
  }
}

export const getEmailByPendingAccountId = async (accountId: string) => {
  const response = await axios.get(`/accounts/${accountId}/email`)
  if (response.status === 200 && response.data.email) {
    return { success: true, email: response.data.email }
  } else {
    return {
      success: false,
      error: response.data.error || 'Account does not exist.'
    }
  }
}

export const requestActivation = async (
  accountId: string,
  password: string
) => {
  const response = await axios.post(`/accounts/signup/activation/request`, {
    accountId,
    password
  })

  if (response.status === 200) {
    return { success: true, message: response.data.message }
  } else {
    return {
      success: false,
      error: response.data.error || 'Failed to send activation request.'
    }
  }
}

export const confirmActivation = async (accountId: string, code: string) => {
  const response = await axios.post(`/accounts/signup/activation/confirm`, {
    accountId,
    code
  })

  if (response.status === 200) {
    return { success: true }
  } else {
    return {
      success: false,
      error: response.data.error || 'Failed to confirm activation.'
    }
  }
}
